<template>
  <div
    class="accesibility"
    :style="{ 
      '--sidebar-width': sidebarWidth,
      '--height': height
    }"
    @click="handleChangeAccesibility"
  >
    <center style="margin-top:15px;color: white;">
      <v-icon style="color: white;font-size: 80px">
        mdi-wheelchair-accessibility
      </v-icon>
      <br />
      <span class="label">{{ $t('totem.accessibility').toUpperCase() }}</span>
    </center>
  </div>
</template>

<script>
import constants from '@/constants'
export default {
  computed: {
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    height() {
      return constants.totem.accessibility.height + 'px'
    }
  },
  methods: {
    handleChangeAccesibility () {
      this.$store.state.app.isTotemAccessibility = true
    }
  }
}
</script>

<style scoped>
.accesibility {
  cursor: pointer;
  position: fixed;
  bottom: 0px;
  background-color: #000000CC;
  width: var(--sidebar-width);
  height: var(--height);
  z-index: 100;
}
</style>
